import i18next from 'i18next';
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { getPrivacy, getTerms } from '../redux/actionCreator';

function Footer({ className }) {
    const { t } = useTranslation();
    const dispatch = useDispatch()
    const [terms, setTerms] = useState({})
    const [privacy, setPrivacy] = useState({})
    useEffect(() => {
        dispatch(getTerms((res) => {
            setTerms(res.data.data)
        }))
        dispatch(getPrivacy((res) => {
            setPrivacy(res.data.data)
        }))
    }, [])

    return (
        <section className={'footer__section' + ' ' + className}>
            <div className="container">
                <div className="row align-items-center" >
                    <div className="col-md-4">
                        <div className="social__links">
                            <ul>
                                <li><a href="https://www.instagram.com/escdubai/" target='_blank' rel="noreferrer"><i className='fab fa-instagram'></i></a></li>
                                <li><a href="https://twitter.com/escdubai" target='_blank' rel="noreferrer">
                                    {/* <i className='fab fa-twitter'></i> */}
                                    <img src="./assets/img/socialIcons/x-twitter-grey.svg" width={16} />
                                </a></li>
                                <li><a href="https://www.linkedin.com/company/escdubai" target='_blank' rel="noreferrer"><i className='fab fa-linkedin-in'></i></a></li>
                                {/* <li><a href="https://www.facebook.com/ESCODXB" target='_blank' rel="noreferrer"><i className='fab fa-facebook-f'></i></a></li> */}
                            </ul>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="terms_privacy">
                            <ul>
                                {
                                    terms != null && <li><Link to={`/${i18next.language}/terms`} rel='noreferrer'>{t('terms')}</Link></li>
                                }
                                {
                                    privacy != null && <li><Link to={`/${i18next.language}/privacy`} rel='noreferrer'>{t('privacy_policy')}</Link></li>
                                }


                            </ul>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="copyright">
                            <p>{t('copyright')} {(new Date().getFullYear())} {t('Economic Security Center of Dubai')}</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Footer